import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex)

export default new Vuex.Store({

  plugins: [createPersistedState()],

  state: {
    user: {},
    loggedIntoFacebook: false,
    agency: {},
    facebookToken: '',
    resellerAccount:{},
    frontEndSubscription: {},
    insightsData: {
      primaryPageId:'',
      agencyId:'',
      subscriptionId: '',
      adAccountId: '',
      pageToken: '',
      singlePage: false
    },
    checkOutLink:'',
    newUser:false,
    newUserPassword:'',
    hasAccess:false
  },

  mutations: {
    setUser(state, userObj) {
      state.user = userObj;
    },
    setFrontEndSubscription(state, subscriptionObj) {
      state.frontEndSubscription = subscriptionObj;
    },
    setAgency(state, agencyObj) {
      state.agency = agencyObj;
    },
    setResellerAccount(state, accountObj) {
      state.resellerAccount = accountObj;
    },
    setUserFacebookToken(state, tokenObj) {
      if (tokenObj == false) {
        state.user.facebookToken = ""
        state.loggedIntoFacebook = false
        console.log('state.user.facebookToken', state.user.facebookToken)
      }
    },
    setloggedIntoFacebook(state, userObj) {
      state.loggedIntoFacebook = userObj;
    },
    logout(state) {
      state.user = null;
      state.loggedIntoFacebook = false
      state.agency = {}
    },
    setUserToken(state, tokenObj) {
      state.facebookToken = tokenObj;
    },
     setInsightsData(state, newData) {
      state.insightsData = newData;
    },
    setCheckOutLink(state, checkOutLink) {
      state.checkOutLink = checkOutLink;
    },
    setIfNewUser(state, newUser){
      state.newUser = newUser;
    },
    setNewUserPassword(state, newUserPassword){
      state.newUserPassword = newUserPassword
    },
    setHasAccess(state, hasAccess){
      state.hasAccess = hasAccess
    }
  },

  getters: {
    getUser(state) {
      return state.user;
    },
    getLoggedInStatus(state) {
      return state.loggedIntoFacebook;
    },
    getAgency(state) {
      return state.agency;
    },
    getResellerAccount(state) {
      return state.resellerAccount;
    },
    getUserFacebookToken(state) {
      return state.facebookToken;
    },
    getFrontEndSubscription(state) {
      return state.frontEndSubscription;
    },
    getInsightsData(state) {
      return state.insightsData;
    },
    getCheckOutLink(state) {
      return state.checkOutLink;
    },
    getIfNewUser(state) {
      return state.newUser;
    },
    getNewUserPassword(state) {
      return state.newUserPassword;
    },
    getHasAccess(state) {
      return state.hasAccess;
    },
  },

})